var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-popup",
    {
      staticClass: "popup-user-reset-password",
      staticStyle: { height: "200px !important" },
      attrs: { id: _vm.nameId, opened: _vm.popupOpened },
      on: {
        "popup:opened": function ($event) {
          _vm.popupOpened = true
        },
        "popup:closed": function ($event) {
          _vm.popupOpened = false
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "container-user-reset-password" },
        [
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "form-group",
                  attrs: { cols: "8", offset: "2" },
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("common.idtfr")) + " "),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-control",
                      staticStyle: { display: "flex", height: "40px" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.login,
                            expression: "login",
                          },
                        ],
                        staticStyle: { border: "none", width: "100%" },
                        attrs: {
                          inputType: "text",
                          placeholder: _vm.$t("common.idtfr"),
                        },
                        domProps: { value: _vm.login },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.login = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "loginButtons" },
            [
              _c(
                "b-col",
                { attrs: { cols: "8", offset: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "lg" },
                      on: {
                        click: function ($event) {
                          return _vm.resetPassword()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("administration.reset_password")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }